import React from "react";
import type { ProjectSetting } from "../types";

type ProjectSettingCtxValue = {
    setting: ProjectSetting | null;
    isLoading: boolean;
}

const ProjectSettingCtx = React.createContext<ProjectSettingCtxValue>({
    setting: null,
    isLoading: true,
});

export function ProjectSettingProvider({
    setting,
    isLoading,
    children,
}: React.PropsWithChildren<ProjectSettingCtxValue>) {
    return (
        <ProjectSettingCtx.Provider value={{ setting, isLoading }}>
            {children}
        </ProjectSettingCtx.Provider>
    )
}

export function useProjectSettingCtx() {
    return React.useContext(ProjectSettingCtx);
}
